import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import {  Autoplay } from "swiper/modules";

const CompanySection = () => {
  const companyImg = [
    "/image/company-section/partner-1.png",
    "/image/company-section/partner-2.png",
    "/image/company-section/partner-3.png",
    "/image/company-section/partner-4.png",
    "/image/company-section/partner-5.png",
    "/image/company-section/partner-6.png",
    "/image/company-section/partner-1.png",
    "/image/company-section/partner-2.png",
    "/image/company-section/partner-3.png",
    "/image/company-section/partner-4.png",
    "/image/company-section/partner-5.png",
    "/image/company-section/partner-6.png",
  ];

  return (
    <div className="padding-top padding-bottom bg-white company_section">
      <div className="container d-flex align-items-center">
        <Swiper
          slidesPerView={6}
          spaceBetween={20}
          navigation={true}
          breakpoints={{
            320: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            572: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
          }}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          modules={[ Autoplay]}
          className="mySwiper"
        >
          {companyImg.map((element, index) => {
            return (
              <SwiperSlide key={index} className="my-5"  >
                <div className="company_img">
                  <img src={element} className="img-fluid" alt="" />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default CompanySection;
